import { FC, ReactNode } from 'react';
import { ProButton } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { ButtonProps } from 'antd/lib/button';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormButtonProps extends BaseSearchFormItemProps {
  /** button Props */
  buttonProps?: ButtonProps;
  children?: ReactNode;
}
/** 按钮 */
export const SearchFormButton: FC<SearchFormButtonProps> = props => {
  const {
    buttonProps,
    children,
    isDetail,
    render,
    disabledRender,
    testId,
    name,
    ...resProps
  } = props;
  return (
    <SearchFormItem {...resProps} name={name}>
      {isDetail || (buttonProps && buttonProps.disabled) ? (
        <SearchFormDisabled name={name} render={render || disabledRender} />
      ) : (
        <ProButton {...buttonProps} test-id={`${testId}-${name}`}>
          {children}
        </ProButton>
      )}
    </SearchFormItem>
  );
};

SearchFormButton.displayName = SearchFormItemEnum.SearchFormButton;

export default SearchFormButton;
